import Dexie, { Table } from 'dexie';

export interface ILogs {
  id?: string;
  date: string;
  userId: number | null;
  userName: string;
  logLevel: string;
  log: string;
}

export class IndexedDB extends Dexie {
  logs!: Table<ILogs>;

  constructor() {
    super('nexview'); // Database name

    this
      .version(1)
      .stores({
        logs: '++id, date, userId, userName, logLevel, log',
      });
  }
}

export const indexedDB = new IndexedDB();
